module.exports = __webpack_public_path__ + "img/photovoltaik-small.91db5ac.webp";